import Link from './Link'
import SpirMonWrapper from '../widgets/Advert/SpirMonWrapper'

/**
 * Link Component wrapped by Spirmon
 */
class SpirmonLink extends Link {}

export default SpirMonWrapper(SpirmonLink)
